import { render } from "./TableView.vue?vue&type=template&id=df9d667c&ts=true"
import script from "./TableView.vue?vue&type=script&lang=ts"
export * from "./TableView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adroneleh/projects/vue-js-matrix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__